import { showToast } from './toast';

export function initCopyToClipboard() {
	document.addEventListener('DOMContentLoaded', () => {
		const buttons = document.querySelectorAll('[data-action="copy-to-clipboard"]');

		buttons.forEach(button => {
			const originalLabel = button.innerHTML;

			button.addEventListener('click', async () => {
				const content = button.getAttribute('data-copy-content');
				const successToast = button.getAttribute('data-copy-success-toast') || 'Copied to clipboard.';
				const errorToast = button.getAttribute('data-copy-error-toast') || 'Unable to copy to clipboard.';

				try {
					await navigator.clipboard.writeText(content);
					showToast({
						message: successToast,
						mode: 'success',
						icon: 'clipboard'
					});
					// button.innerHTML = 'Copied! <i class="fa-regular fa-check"></i>';
					button.disabled = true;

					setTimeout(() => {
						// button.innerHTML = originalLabel;
						button.disabled = false;
					}, 3000);
				} catch (err) {
					console.error('Clipboard copy failed', err);
					showToast({
						message: errorToast,
						mode: 'error',
						// icon: 'clipboard'
					});
				}
			});
		});
	});
}